import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export default function formatDate(hour) {
  return format(parseISO(hour), "HH:mm'h", {
    locale: ptBR,
  });
}
